import sessionHandler from "./middleware/sessionHandler";
import session, {
    initSession
} from "./ducks/session";
import projectReducer from "./ducks/project";
import titleReducer from "./ducks/title";
import taskReducer from "./ducks/task";
import userReducer from "./ducks/user";
import glossaryReducer from "./ducks/glossary";
import memoryReducer from "./ducks/memory";
import analysisReducer from "./ducks/analysis";

import {
    configureStore,
    getDefaultMiddleware
} from '@reduxjs/toolkit'
import saveHandler from "./middleware/saveHandler";

const store = configureStore({
    reducer: {
        session: session,
        project: projectReducer,
        title: titleReducer,
        task: taskReducer,
        user: userReducer,
        glossary: glossaryReducer,
        memory: memoryReducer,
        analysis: analysisReducer
    },
    middleware: getDefaultMiddleware().concat(sessionHandler).concat(saveHandler)
});

store.dispatch(initSession());

export default store;